/**
 * 时间日期处理工具类
 */
import dayjs from 'dayjs'

/**
 * 格式化
 */
export const FORMAT_TEMPLATE = {
  DATE: 'YYYY-MM-DD',
  TIME: 'YYYY-MM-DD HH:mm:ss',
}

/**
 * 格式化时间字符串
 * @param {*} timeStr 合法的时间字符串
 * @returns 格式化后日期字符串，eg: 2020/12/12 12:12:13 -> 2020-12-12
 */
export function formatDate(timeStr) {
  var dayjsValue = dayjs(timeStr)
  if (dayjsValue.isValid()) {
    return dayjsValue.format(FORMAT_TEMPLATE.DATE)
  } else {
    return ''
  }
}

/**
 * 格式化时间字符串
 * @param {*} timeStr 合法的时间字符串
 * @returns 格式化后时间字符串，eg: 2020/12/12 12:12:13 -> 2020-12-12 12:12:12
 */
export function formatTime(timeStr) {
  var dayjsValue = dayjs(timeStr)
  if (dayjsValue.isValid()) {
    return dayjsValue.format(FORMAT_TEMPLATE.TIME)
  } else {
    return ''
  }
}

/**
 * 获取一周前 ,6天前 日期字符串
 * @returns {String} 日期字符串，eg: 2021-07-27
 */
export function beforeWeekDate() {
  return dayjs()
    .add(-6, 'day')
    .format(FORMAT_TEMPLATE.DATE)
}

/**
 * 获取当天 日期字符串
 * @returns {String} 日期字符串，eg: 2021-07-27
 */
export function nowDate() {
  return dayjs().format(FORMAT_TEMPLATE.DATE)
}

/**
 * 获取当前时间字符串 时间字符串
 * @returns {String} 时间字符串，eg: 2021-07-27 12:12:12
 */
export function now() {
  return dayjs().format(FORMAT_TEMPLATE.TIME)
}
/**
 * 获取当天 日期字符串
 * @returns {String} 日期字符串，eg: 2021-07-27 00:00:00
 */
export function nowTime() {
  return dayjs().format(FORMAT_TEMPLATE.TIME)
}
/**
 * 获取日期 年月日
 * @param {Date} daytime --日期
 */
export function datetimeFull(datetime) {
  var dateValue = new Date(new Date(new Date(datetime).toLocaleDateString()).getTime())
  var months = dateValue.getMonth() + 1 < 10 ? '0' + (dateValue.getMonth() + 1) : dateValue.getMonth() + 1
  var days = dateValue.getDate() < 10 ? '0' + dateValue.getDate() : dateValue.getDate()
  return dateValue.getFullYear() + '-' + months + '-' + days
}
/**
 * 增减指定天数后返回特定格式
 * @returns {String} 时间字符串，eg: 2021-07-27
 */
export function addDay(timeStr, day) {
  var dayjsValue = dayjs(timeStr)
  if (dayjsValue.isValid()) {
    return dayjsValue.add(day, 'day').format(FORMAT_TEMPLATE.DATE)
  } else {
    return ''
  }
}
/**
 * 获取一月前, 日期字符串
 * @returns {String} 日期字符串，eg: 2021-07-27
 */
export function beforeMonthDate() {
  return dayjs()
    .add(-30, 'day')
    .format(FORMAT_TEMPLATE.DATE)
}

/**
 * 获取一周前,6天前 日期字符串
 * @returns {String} 日期字符串，eg: 2021-07-27 00:00:00
 */
export function beforeWeek() {
  return dayjs()
    .add(-6, 'day')
    .format(FORMAT_TEMPLATE.TIME)
}
/**
 * 获取一月前, 日期字符串
 * @returns {String} 日期字符串，eg: 2021-07-27  00:00:00
 */
export function beforeMonthTime() {
  return dayjs()
    .add(-30, 'day')
    .format(FORMAT_TEMPLATE.TIME)
}
/**
 * 获取当月第一天, 日期字符串
 * @returns {String} 日期字符串，eg: 2021-07-27  00:00:00
 */
export function startMonthTime() {
  return dayjs()
    .startOf('month')
    .format(FORMAT_TEMPLATE.TIME)
}
/**
 * 计算两个日期的相差天数
 * @param {Date} date1 --日期1
 * @param {Date} date2 --日期2
 * @returns {String} 相差天数
 */
export function getDaysDiff(date1, date2) {
  console.log(date1, date2)
  const timeDiff = Math.abs(new Date(date2).getTime() - new Date(date1).getTime());
  const daysDiff = Math.ceil(timeDiff / (24 * 60 * 60 * 1000));
  return daysDiff;
}